import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SysAdminService } from "../../services/sysadmin.service";
import { UserGroupAddUsersComponent } from "./user-group-add-users/user-group-add-users.component";
import { UsersToChangeModel } from "./UsersToChangeModel";

@Component({
	selector: "caass-user-group-user-table",
	templateUrl: "./user-group-user-table.component.html",
	styleUrls: ["./user-group-user-table.component.css"],
})
export class UserGroupUserTableComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private dialogService: DialogService) {}

	ngOnInit(): void {}

	ngOnChanges() {
		this.errorMessage = "";

		if (this.SelectedUserGroup != undefined && this.SelectedUserGroup != null) {
			this.loadUserList();
		} else {
			this.lstUsers = [];
		}
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	@Input() SchoolID: any;
	@Input() SelectedUserGroup: any;

	SelectedUsers: any = [];
	lstUsers: any = [];

	cols = [
		{ field: "UserName", header: "User Name" },
		{ field: "PersonName", header: "Person Name" },
	];

	pagerows: any = 5;
	pagefirst: any = 0;

	errorMessage: any = "";

	loading: any = false;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	private loadUserList() {
		this.loading = true;

		var result = this.sysAdminService.UsersGetByUserGroup(this.SelectedUserGroup.UserGroupID);
		result.subscribe(
			(response) => {
				this.lstUsers = response;
				this.SelectedUsers = [];

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.SelectedUserGroup == undefined || this.SelectedUserGroup == null) {
			this.errorMessage = "Select a User Group to add users to";
			return;
		}

		var ref = this.dialogService.open(UserGroupAddUsersComponent, {
			header: "Add Users",
			width: "fit-content",
			data: {
				UserLevelID: this.SelectedUserGroup.UserLevelID,
				SchoolID: this.SchoolID,
				SelectedUsers: this.lstUsers,
				UserGroupID: this.SelectedUserGroup.UserGroupID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadUserList();
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		// if(this.SelectedUsers.length == 0){
		//   this.errorMessage = "Select users to remove";
		//   return;
		// }

		var lstUserID: number[] = [];

		for (var i = 0; i < this.SelectedUsers.length; i++) {
			var next = Number(this.SelectedUsers[i].UserID);
			lstUserID = [...lstUserID, next];
		}

		//Create Query Data
		let data: UsersToChangeModel = {
			UserGroupID: this.SelectedUserGroup.UserGroupID,
			UserIDs: lstUserID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupRemoveUsers(data);
		result.subscribe(
			(response) => {
				this.loadUserList();
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	/////////////////////////////////////////
}
